/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Presentational layout for the ViewAppointments page.
 * @module pages/viewAppointments/ViewAppointmentsView
 */

import styles from "../../styles/ViewAppointments.module.css";
import ViewAppointmentsHeader from "./ViewAppointmentsHeader.jsx";
import ViewAppointmentsSearchControls from "./ViewAppointmentsSearchControls.jsx";
import ViewAppointmentsTablePanel from "./ViewAppointmentsTablePanel.jsx";
import ViewAppointmentsCalendarPanel from "./ViewAppointmentsCalendarPanel.jsx";
import ViewAppointmentsOverlays from "./ViewAppointmentsOverlays.jsx";

/**
 * Renders the ViewAppointments page from grouped view-model sections.
 * @param {Object} props
 * @param {Object} props.header - Header and back navigation props
 * @param {Object} props.search - Search and filter control props
 * @param {Object} props.table - Appointments table props
 * @param {Object} props.calendar - Calendar panel props
 * @param {Object} props.overlays - Portals, modals, and toast props
 * @param {string} props.registeredMembersTitle - Localized section title
 */
const ViewAppointmentsView = ({
  header,
  search,
  table,
  calendar,
  overlays,
  registeredMembersTitle,
}) => (
  <div className={styles.container}>
    <ViewAppointmentsHeader {...header} />

    <div className={styles.content}>
      <div className={styles.registeredMembersSection}>
        <h2 className={styles.registeredMembersTitle}>
          {registeredMembersTitle}
        </h2>
      </div>

      <ViewAppointmentsSearchControls {...search} />

      <div className={styles.panelsContainer}>
        <ViewAppointmentsTablePanel {...table} />
        <ViewAppointmentsCalendarPanel {...calendar} />
      </div>
    </div>

    <ViewAppointmentsOverlays {...overlays} />
  </div>
);

export default ViewAppointmentsView;
